import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';
import {runGuestPickerBedroomsExperiment, runGuestPickerAgeofChildrenExperiment} from '../../../utils/experiments';

import {useOptions} from './useOptions';

const defaultGuestsOptions = {
    actionLocation: undef,
    adultsMax: undef,
    adultsMin: undef,
    ageOptions: {
        minValue: 0,
        maxValue: 17,
        minAge: undef,
        undefAgesValue: {
            value: '-',
            label: '-',
            disabled: true,
        },
        useUndefAges: true,
    },
    allowErrorHighlighting: undef,
    autoSubmit: undef,
    bedroomsMax: undef,
    bedroomsMin: undef,
    centered: undef,
    childrenMax: undef,
    childrenMin: undef,
    disableTextInput: undef,
    fadeOut: false,
    fadeOutDuration: 0,
    id: 'guests',
    inputIconName: 'group',
    name: 'guests',
    placement: 'bottom',
    positionIconRight: undef,
    showAgeRanges: undef,
    showAgeSelect: undef,
    showBedroomsOption: undef,
    showClearButton: false,
    showContinue: undef,
    showInputIcon: undef,
    showPetOption: true,
    wdioPrefix: undef
};

function useGuestsOptions(props, abacusStore) {
    const {
        guestsOptions: propsGuestsOptions
    } = props;

    const showAgeSelectExperiment = runGuestPickerAgeofChildrenExperiment({shouldLogExperiment: true}, abacusStore) || undef;

    const experimentGuestsOptions = {
        showBedroomsOption: runGuestPickerBedroomsExperiment({shouldLogExperiment: false}, abacusStore) || undef,
        showAgeRanges: showAgeSelectExperiment,
        showAgeSelect: showAgeSelectExperiment
    };

    const {
        options: guestsOptions
    } = useOptions(defaultGuestsOptions, experimentGuestsOptions, propsGuestsOptions);

    const result = {
        guestsOptions
    };

    useDebugValue(result);

    return result;
}

export {useGuestsOptions};
